import '../App.css';

function Parcours() {
    const experiences = [
        {
            period: 'April 2026 - June 2026 (2 months)',
            title: 'DRIME - Full-stack Developer Intern',
            details: '2-month internship in production full-stack development: React/TypeScript features, Laravel REST APIs, Python automation scripts and bug fixing.'
        }
    ];

    const education = [
        {
            period: '2024 - 2027',
            title: 'BUT Computer Science',
            subtitle: 'IUT Grand Ouest Normandie - Ifs Campus 3'
        },
        {
            period: '2020 - 2021',
            title: 'OpenClassrooms Self-learning',
            subtitle: 'HTML/CSS, Python, Algorithms'
        }
    ];

    return (
        <section className="px-4 sm:px-6 md:px-10 lg:px-16 pt-24 md:pt-28 pb-10 md:pb-14">
            <div className="max-w-6xl mx-auto space-y-10">
                <header className="parcours-header-card">
                    <p className="parcours-kicker">Parcours</p>
                    <h1 className="parcours-title">Experience, education and technical profile</h1>
                    <p className="parcours-subtitle">
                        Second-year Computer Science student, autonomous and versatile, building concrete full-stack projects while looking for a 2026-2027 work-study opportunity.
                    </p>
                </header>

                <div className="grid lg:grid-cols-[1.3fr_0.9fr] gap-6 md:gap-8">
                    <div className="timeline-card">
                        <h2>Experience</h2>
                        <div className="space-y-5 mt-6">
                            {experiences.map((item) => (
                                <article key={item.title} className="timeline-item">
                                    <span className="timeline-period">{item.period}</span>
                                    <h3>{item.title}</h3>
                                    <p className="timeline-details">{item.details}</p>
                                    {item.stack && <p className="timeline-type mt-2">{item.stack}</p>}
                                </article>
                            ))}
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="skills-card">
                            <h2>Education</h2>
                            <div className="space-y-4 mt-5">
                                {education.map((item) => (
                                    <article key={item.title}>
                                        <p className="timeline-period">{item.period}</p>
                                        <h3 className="font-bold text-slate-900 mt-1">{item.title}</h3>
                                        <p className="text-sm text-slate-600 mt-1">{item.subtitle}</p>
                                    </article>
                                ))}
                            </div>
                        </div>

                        <div className="skills-card">
                            <h2>Technical Skills</h2>
                            <div className="space-y-3 mt-5 text-sm text-slate-700">
                                <p><strong>Frameworks/Libraries:</strong> Next.js, ReactJS, NestJS, React Native, VueJS, Laravel, Tailwind</p>
                                <p><strong>SQL:</strong> MySQL, MariaDB, Oracle, PostgreSQL</p>
                                <p><strong>Languages:</strong> JavaScript, TypeScript, Python, Java, C, HTML/CSS, PHP, Kotlin</p>
                                <p><strong>Tools:</strong> Git, GitHub, VS Code, Figma, Docker, Bash</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Parcours;
